export default __webpack_public_path__ + "static/media/bbq_chicken_and_sausage.dafea5bb.png";